module.exports = __webpack_public_path__ + "static/media/graduate-1.3d434dd1.png";